
import QuickPractitioner from 'components/QuickPractitioner/QuickPractitioner'
import React from 'react'
import doctor_kit_icon from "assets/svgIcon/doctor-kit-icon.svg";
import star_fill from "assets/svgIcon/star-fill.svg";
import hos_bg from "assets/images/hos-bg-2.png";

export default function NearbyHospitals() {
  return (
    <div className='nex-quick-hospital-card'>
        <h3 className='nex-text-xl nex-card-title nex-color-dark-blue'>Nearby hospitals</h3>
        <div className="nex-quick-hospital-columns">
          <div className="nex-quick-hospital-item">
              <div className="graphic" style={{backgroundImage: 'url('+hos_bg+')'}}></div>
              <div className="info">
                  <div className="nex-flex">
                    <div className="profile-info">
                        <QuickPractitioner 
                          name="Gahtori Hospital Kashipur"
                          address="Test1dd, Udham Singh Nagar, Uttarakhand, India" 
                        />
                    </div>
                    <div className="profile-extra-links">
                        <a href=""><span className='icon'><img src={doctor_kit_icon} alt="" /></span> 150+ Doctors</a>
                    </div>
                  </div>
                  <div className="nex-review">
                      <div className="star">
                        <span className='icon'><img src={star_fill} alt="" /></span>  
                        <span className='icon'><img src={star_fill} alt="" /></span>  
                        <span className='icon'><img src={star_fill} alt="" /></span>  
                        <span className='icon'><img src={star_fill} alt="" /></span>  
                        <span className='icon'><img src={star_fill} alt="" /></span>  
                      </div><div className="ratings"><a href="">1345 Reviews</a></div>
                  </div>
                  
              </div>
          </div>
          <div className="nex-quick-hospital-item">
              <div className="graphic" style={{backgroundImage: 'url('+hos_bg+')'}}></div>
              <div className="info">
                  <div className="nex-flex">
                    <div className="profile-info">
                        <QuickPractitioner 
                          name="Gahtori Hospital Kashipur"
                          address="Test1dd, Udham Singh Nagar, Uttarakhand, India" 
                        />
                    </div>
                    <div className="profile-extra-links">
                        <a href=""><span className='icon'><img src={doctor_kit_icon} alt="" /></span> 150+ Doctors</a>
                    </div>
                  </div>
                  <div className="nex-review">
                      <div className="star">
                        <span className='icon'><img src={star_fill} alt="" /></span>  
                        <span className='icon'><img src={star_fill} alt="" /></span>  
                        <span className='icon'><img src={star_fill} alt="" /></span>  
                        <span className='icon'><img src={star_fill} alt="" /></span>  
                        <span className='icon'><img src={star_fill} alt="" /></span>  
                      </div><div className="ratings"><a href="">1345 Reviews</a></div>
                  </div>
                  
              </div>
          </div>
        </div>
    </div>
  )
}
